const CorrelationStacking = {
    CORRELATION_STACKING_SET_DATA_FROM_STORAGE: 'CORRELATION_STACKING_SET_DATA_FROM_STORAGE',

    CORRELATION_STACKING_SET_IS_USED: 'CORRELATION_STACKING_SET_IS_USED',

    CORRELATION_STACKING_SET_UNIVERSAL_RULE: 'CORRELATION_STACKING_SET_UNIVERSAL_RULE',

    CORRELATION_STACKING_ADD_ITEM: 'CORRELATION_STACKING_ADD_ITEM',
    CORRELATION_STACKING_REMOVE_ITEM: 'CORRELATION_STACKING_REMOVE_ITEM',

    CORRELATION_STACKING_SET_BOOST: 'CORRELATION_STACKING_SET_BOOST',
    CORRELATION_STACKING_SET_KEY_PLAYER_ID: 'CORRELATION_STACKING_SET_KEY_PLAYER_ID',
    CORRELATION_STACKING_SET_STACK_PLAYERS: 'CORRELATION_STACKING_SET_STACK_PLAYERS',
    CORRELATION_STACKING_SET_FIRST_TEAM_AT_LEAST_PLAYERS: 'CORRELATION_STACKING_SET_FIRST_TEAM_AT_LEAST_PLAYERS',
    CORRELATION_STACKING_SET_FIRST_TEAM_AT_MOST_PLAYERS: 'CORRELATION_STACKING_SET_FIRST_TEAM_AT_MOST_PLAYERS',
    CORRELATION_STACKING_SET_SECOND_TEAM_AT_LEAST_PLAYERS: 'CORRELATION_STACKING_SET_SECOND_TEAM_AT_LEAST_PLAYERS',
    CORRELATION_STACKING_SET_SECOND_TEAM_AT_MOST_PLAYERS: 'CORRELATION_STACKING_SET_SECOND_TEAM_AT_MOST_PLAYERS',
    CORRELATION_STACKING_SET_STACK_TYPE: 'CORRELATION_STACKING_SET_STACK_TYPE',
    CORRELATION_STACKING_SET_MIN_EXPOSURE: 'CORRELATION_STACKING_SET_MIN_EXPOSURE',

    CORRELATION_STACKING_SET_SECONDARY_STACK_TYPE: 'CORRELATION_STACKING_SET_SECONDARY_STACK_TYPE',
    CORRELATION_STACKING_SET_SECONDARY_STACK_COMBINATION_TYPE:
        'CORRELATION_STACKING_SET_SECONDARY_STACK_COMBINATION_TYPE',

    CORRELATION_STACKING_SET_UNIVERSAL_STACK_COMBINATION_TYPE:
        'CORRELATION_STACKING_SET_UNIVERSAL_STACK_COMBINATION_TYPE',

    CORRELATION_STACKING_PATCH_STACK_PLAYER: 'CORRELATION_STACKING_PATCH_STACK_PLAYER',

    CORRELATION_STACKING_TYPE_GAME: 'game',
    CORRELATION_STACKING_TYPE_TEAM: 'team',

    CORRELATION_STACKING_BOOST_COEFFICIENT: 1.3,

    CORRELATION_SECONDARY_STACK_TYPE_NONE: 0,
    CORRELATION_SECONDARY_STACK_TYPE_SINGLE: 1,
    CORRELATION_SECONDARY_STACK_TYPE_DOUBLE: 2,

    CORRELATION_SECONDARY_STACK_COMBINATION_PLAYERS_QUANTITY: 2,

    CORRELATION_STACKING_STACKABLE_PLAYER_POSITION_NAMES: ['WR', 'TE', 'RB'],
};

// If combination types are changed then compatible types have to be change also
CorrelationStacking.CORRELATION_STACKING_SECONDARY_COMPATIBLE_TYPES = {
    oneTeam: [
        [1, 2],
        [1, 3],
        [1, 4],
        [2, 3],
        [3, 4],
        [1, 5],
        [2, 5],
        [3, 5],
    ],
    oppositeTeams: [
        [1, 2],
        [1, 3],
        [1, 5],
        [2, 2],
        [2, 3],
        [2, 5],
    ],
};

export default CorrelationStacking;
